export function objHasEmptyProp(obj = {}) {
  return Object.values(obj).some(
    el => el === '' || el === null || el === undefined,
  );
}
